import Image from 'core/display/Image'
import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { KeyboardManager } from 'managers/KeyboardManager'
import { signal } from 'services/SignalsService'

export default class ReverseToggleButton {
  constructor(data) {
    this.self = new Image(data)
    this.images = this.self.images
    this.id = `TOGGLE:${data.name}`
    this.state = true

    this.createSignal()

    KeyboardManager.register({ id: this.id, tap: this.tap.bind(this) })
    enableTap(this.self, this.tap.bind(this))

    return this.self
  }

  createSignal(){
    signal.on(this.id, function (value) {
      this.state = !value
      this.images[0].visible = !this.state
      this.images[1].visible = this.state
    })
  }

  tap(){
    ButtonManager.dispatch(this.id, this.state)
  }
}
